import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function FeaturedContent() {
  const featured = articles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="py-12 md:py-16 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-1">编辑团队精心挑选的优质内容</p>
          </div>
          <Link
            to="/category/video"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={article.cover_image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.description}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span>{article.publish_date}</span>
                  <span>{article.read_time}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}